import { Link } from "react-router-dom";
import { ClipboardList, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion";

// Banner CTA hacia el cuestionario de onboarding (patrocinadores / marcas)
export const OnboardingCTA = ({ to, accent = "#FF8A80", title, text }) => (
  <section className="px-5 sm:px-8 lg:px-12 py-10">
    <div className="mx-auto max-w-7xl">
      <Reveal className="overflow-hidden rounded-[2.5rem] bg-ink text-cream shadow-[0_20px_40px_rgb(0,0,0,0.15)]">
        <div className="flex flex-col items-start gap-6 p-9 sm:p-12 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex items-start gap-5">
            <span
              className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl"
              style={{ backgroundColor: accent }}
            >
              <ClipboardList className="h-7 w-7 text-ink" strokeWidth={2.2} />
            </span>
            <div>
              <h2 className="font-display text-3xl sm:text-4xl font-extrabold leading-none tracking-tighter">
                {title}
              </h2>
              <p className="mt-3 max-w-xl text-cream/70 leading-relaxed">{text}</p>
            </div>
          </div>
          <Link
            to={to}
            data-testid="onboarding-cta"
            className="group inline-flex shrink-0 items-center gap-2 rounded-full px-7 py-4 font-semibold text-ink transition-all duration-300 hover:-translate-y-0.5"
            style={{ backgroundColor: accent }}
          >
            Iniciar onboarding
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);
